import JumboScrollbar from "@jumbo/components/JumboScrollbar";
import Div from "@jumbo/shared/Div";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableHead,
    TableRow,
    TableCell,
    Typography,
} from "@mui/material";
import useResponsive from "app/pages/useResponsive";
import { BASE_URL } from "app/services/auth-services";
import { formatIndianNumber } from "app/shared/ReuseComponents/DateFormatter";
import axios from "axios";
import React, { useEffect } from "react";
import { MdClose } from "react-icons/md";



const PayslipDocumentApproval = ({
    scrollHeight,
    openViewRequest,
    setOpenViewRequest,
    setCloseRequest,
    requests,
    setRequests,
}) => {

    let isMobile = useResponsive("down", "md");

    console.log("requestsrequests", requests)

    useEffect(() => {
        const fetchPayslipData = async () => {
            try {
                const response = await axios.get(
                    `${BASE_URL}/Felix/PayslipHeaderList/`,
                    {
                        params: {
                            Partner_Id: requests?.Partner_Id,
                            Year: requests?.Year,
                            Month: requests?.Month
                        }
                    }
                );

                if (response?.data) {
                    setRequests(response?.data?.filter((opt) => opt?.Noof_DaysPresent > 0));
                }
            } catch (error) {
                console.error("Error fetching payslip data:", error);
            }
        };

        if (requests?.Partner_Id && requests?.Year && requests?.Month) {
            fetchPayslipData();
        } else {
            console.warn("Missing required parameters for payslip fetch");
        }
    }, [requests?.Partner_Id, requests?.Year, requests?.Month]);


    return (
        <>
            <Dialog maxWidth="xl" fullWidth open={openViewRequest}>
                <DialogTitle
                    sx={{ display: "flex", justifyContent: "space-between", mb: -2 }}
                >
                    <Div sx={{ fontSize: "18px" }}>View Payroll</Div>
                    <Div>
                        <IconButton
                            onClick={() => {
                                setOpenViewRequest(false);
                                setCloseRequest(true);
                            }}
                        >
                            <MdClose />
                        </IconButton>
                    </Div>
                </DialogTitle>
                <DialogContent>
                    <Grid container>
                        <Grid item xs={12}>
                            <JumboScrollbar
                                autoHeight={true}
                                autoHideTimeout={4000}
                                autoHeightMin={scrollHeight ? scrollHeight : 530}
                                autoHide={true}
                                hideTracksWhenNotNeeded
                                id="no-more-tables"
                            >
                                <Table stickyHeader className="table" sx={{ minWidth: { xs: "100% !important", md: "500px !important" } }}>
                                    <TableHead className="table-head">
                                        <TableRow>
                                            <TableCell sx={{ minWidth: "100px !important" }}>Employee Name</TableCell>
                                            <TableCell sx={{ minWidth: "100px !important" }}>Department</TableCell>
                                            <TableCell sx={{ minWidth: "80px !important" }}>Days(P)</TableCell>
                                            <TableCell sx={{ minWidth: "80px !important" }}>LOP</TableCell>
                                            <TableCell sx={{ minWidth: "250px !important" }}>Earning & Deduction</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {requests && requests?.length > 0 ? requests
                                            .filter(data => data?.Noof_DaysPresent > 0)?.map((data, index) => {
                                                const totalEarningsBeforeArrear = data?.Salary_Details?.Other_Details?.Earnings?.reduce(
                                                    (sum, obj) =>
                                                        obj?.earningDeductionType === "Earning"
                                                            ? sum + obj.monthly
                                                            : sum,
                                                    0
                                                );

                                                const totalEarningsAfterArrear = data?.Salary_Details?.Other_Details?.Earnings?.reduce(
                                                    (sum, obj) =>
                                                        obj?.Arrear?.earningDeductionType === "Earning"
                                                            ? sum + obj?.Arrear?.monthly
                                                            : sum,
                                                    0
                                                );

                                                const totalEarnings = totalEarningsBeforeArrear + (totalEarningsAfterArrear || 0)

                                                const totalDeductions = data?.Salary_Details?.Other_Details?.Deductions?.reduce(
                                                    (sum, obj) =>
                                                        obj?.earningDeductionType === "Deduction"
                                                            ? sum + obj.monthly
                                                            : sum,
                                                    0
                                                );

                                                // const daysPresent = (Number(data?.Noof_Daysinmonth) - (Number(data?.Noof_DaysPresent) + Number(data?.NoofDays_Leave) + Number(data?.LOP))) + Number(data?.Noof_DaysPresent) + Number(data?.NoofDays_Leave)
                                                const daysPresent = Number(data?.Noof_DaysPresent)
                                                const daysAbsent = Number(data?.LOP)

                                                return (
                                                    <TableRow key={index} hover>
                                                        <TableCell data-title="Employee Name"
                                                            sx={{
                                                                color: "#017890",
                                                                cursor: "pointer",
                                                                lineHeight: 2.5,
                                                            }}
                                                        >
                                                            {data?.Employee_Name}{" "}
                                                            <span> - {data?.Employee_Id}</span>
                                                            <Typography textAlign="left" color="#000000">
                                                                {data?.Designation}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell data-title="Department">{data?.Department}</TableCell>
                                                        <TableCell data-title="Days(P)">{daysPresent}</TableCell>
                                                        <TableCell data-title="LOP">{daysAbsent}</TableCell>
                                                        <TableCell data-title="Earning & Deduction" sx={{ minWidth: "250px !important" }}>
                                                            <Div className="row">
                                                                <Div className="col-6 col-sm-5 col-md-5 col-xl-6" sx={{ display: { xs: "none", md: "block" } }}>
                                                                    <Typography variant="h5">Gross.Earning</Typography>
                                                                    <Typography variant="h5">Deduction</Typography>
                                                                    <Typography variant="h5">Net Pay</Typography>
                                                                </Div>
                                                                <Div className="col-6 col-sm-7 col-md-7 col-xl-6" sx={{ display: { xs: "none", md: "block" } }}>
                                                                    <Typography variant="h5">
                                                                        : {formatIndianNumber(totalEarnings)}
                                                                    </Typography>
                                                                    <Typography variant="h5">
                                                                        : {formatIndianNumber(totalDeductions)}
                                                                    </Typography>
                                                                    <Typography variant="h5">
                                                                        : 
                                                                        {/* {formatIndianNumber(totalEarnings - totalDeductions)} */}
                                                                        {formatIndianNumber(data?.Salary_Details?.This_Month_Salary)}
                                                                    </Typography>
                                                                </Div>

                                                                {/* for mobile responsive */}

                                                                <Div className="col-6 col-sm-5 col-md-5 col-xl-6" sx={{ display: { xs: "block", md: "none" } }}>
                                                                    <Typography variant="h5">Gross.Earning</Typography>
                                                                    <Typography variant="h5">
                                                                        {formatIndianNumber(totalEarnings)}
                                                                    </Typography>
                                                                    <Typography variant="h5">Deduction</Typography>
                                                                    <Typography variant="h5">
                                                                        {formatIndianNumber(totalDeductions)}
                                                                    </Typography>
                                                                    <Typography variant="h5">Net Pay</Typography>
                                                                    <Typography variant="h5">
                                                                        {formatIndianNumber(totalEarnings - totalDeductions)}
                                                                    </Typography>
                                                                </Div>
                                                            </Div>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            }) : (
                                            <TableRow>
                                                {isMobile ?
                                                    <Div className="text-center">
                                                        No Records
                                                    </Div> :
                                                    <TableCell colSpan={8} className="text-center">
                                                        No Records
                                                    </TableCell>
                                                }
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </JumboScrollbar>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </>
    )
}


export default PayslipDocumentApproval